import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, getToken } from './hubApi';

const Ctx = createContext({ user: null, setUser: () => {}, refresh: () => {}, tick: 0, health: null, ready: false });
export const useApp = () => useContext(Ctx);

export function HubProvider({ signedIn, children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [health, setHealth] = useState(null);
  const [tick, setTick] = useState(0);
  const refresh = useCallback(() => setTick(t => t + 1), []);
  useEffect(() => { api('/health').then(setHealth).catch(() => {}); }, [tick]);
  useEffect(() => {
    if (!signedIn || !getToken()) { setUser(null); setReady(true); return; }
    api('/me').then(setUser).catch(() => setUser(null)).finally(() => setReady(true));
  }, [signedIn]);
  return React.createElement(Ctx.Provider, { value: { user, setUser, refresh, tick, health, ready } }, children);
}
